import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getOfficeBreakdownTableView } from '../../../common/components/table/tableViews/agentMovement';
import { additionalTableHeaders, officeBreakdownColumns } from "../tableSettings";
import { getColumnsFromTableView } from '../../../common/helpers/table';
import { useSearchStore } from '../../../store/store';
import { getAgentMovementOfficeBreakdown } from '../../../service/proficiency-metrics';

export const useOfficeBreakdownTable = () => {
    const { pathname } = useLocation();
    const {
        shouldShowAdditionalInfo,
        searchCriteria
    } = useSearchStore((state) => {
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns = {} } = moduleState;
        const { selectedBreakdownTab, tabsByRoute } = breakdowns;
        const breakdownTabData = tabsByRoute?.[pathname]?.[selectedBreakdownTab];
        return ({
            shouldShowAdditionalInfo: breakdownTabData?.shouldShowAdditionalInfo ?? false,
            searchCriteria: moduleState?.search?.searchCriteria,
        });
    });
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const tableView = getOfficeBreakdownTableView(shouldShowAdditionalInfo);
    const columns = getColumnsFromTableView(tableView);

    useEffect(() => {

        const fetchOfficeBreakdown = async () => {
            setIsLoading(true);
            try {
                const result = await getAgentMovementOfficeBreakdown(searchCriteria);
                setRowData(result.results);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                setIsLoading(false);
            }
        };
        fetchOfficeBreakdown();
    }, [searchCriteria]);

    const tableProps = {
        key: tableView?.id,
        additionalTableHeaders,
        rowData: rowData,
        tableTitleWithTooltips: officeBreakdownColumns,
        tableView,
        isTableAutoHeight: false,
        columns,
    };

    return {tableProps, isLoading};
};
